/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneContent({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneContent",
  parentRef,
  backgroundColor,
  borderColor,
  optionsWidth,
  optionValue,
  maxWidth,
  width = "100%",
  size,
  dock,
  disabled,
  focused,
  invalid,
  selectedPlaceholder,
  from,
  hovered,
  valid,
  placeholder,
  value,
  isSelected,
  isMultiChoice,
  onClick,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  onChangeFilter,
  valueFilter,
  onKeyUp,
  isShowingOptions,
  innerRef,
  inputRef,
  fromCustom,
  onClickAddFilterAsCustomOption,
  isShowingAddFilterAsCustomOption,
  selected,
  optionsLeft,
  optionsTop,
  optionsRef
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtTysiainputcontentBackgroundcolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.backgroundColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryFocused = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.focused'
        })
let dtTysiainputcontentBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.invalid'
        })
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
let borderColorOrdtColorsNeutral300 = borderColor ?? dtColorsNeutral300
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneContent.Horizontal"
  data-view-path={viewPath}
 ref={parentRef}
 optionsWidth={optionsWidth}
 optionValue={optionValue}
 style={{'--mw-10-1uJchM': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--w-11-1uJchM': typeof width === 'number' ? `${width}px` : width,'--pb-7-1uJchM': size === "small" ? "4px" : "5px",'--pt-8-1uJchM': size === "small" ? "4px" : "5px",'--h-9-1uJchM': size === "small" ? "24px" : "30px",'--bblr-2-1uJchM': dock === "left" ? "0px" : "4px",'--btlr-4-1uJchM': dock === "left" ? "0px" : "4px",'--bbrr-3-1uJchM': dock === "right" ? "0px" : "4px",'--btrr-5-1uJchM': dock === "right" ? "0px" : "4px",'--bc-1-1uJchM': disabled ? dtTysiainputcontentBackgroundcolorPrimaryDisabled : backgroundColorOrdtColorsWhite,'--bc-6-1uJchM': disabled ? dtTysiainputcontentBordercolorPrimaryDisabled : focused ? dtTysiainputcontentBordercolorPrimaryFocused : invalid ? dtTysiainputcontentBordercolorPrimaryInvalid : borderColorOrdtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 width={optionsWidth}
 selectedPlaceholder={selectedPlaceholder}
 from={from}
 size={size}
 dock={dock}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 placeholder={placeholder}
 value={value}
 isSelected={isSelected}
 isMultiChoice={isMultiChoice}
 onClick={onClick}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 onChangeFilter={onChangeFilter}
 valueFilter={valueFilter}
 optionValue={optionValue}
 onKeyUp={onKeyUp}
 isShowingOptions={isShowingOptions}
 innerRef={innerRef}
 inputRef={inputRef}
 fromCustom={fromCustom}
 onClickAddFilterAsCustomOption={onClickAddFilterAsCustomOption}
 isShowingAddFilterAsCustomOption={isShowingAddFilterAsCustomOption}
 selected={selected}
 optionsLeft={optionsLeft}
 optionsTop={optionsTop}
 optionsRef={optionsRef}
 optionsWidth={optionsWidth}
>
{children}
</Children>
</div>
</React.Fragment>)
}